'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DESearchDataflow = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _withDataflow = require('./with-dataflow');

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _glamorous2.default.div({
  display: 'flex',
  borderBottom: '1px solid ' + _.Colors.GREY4,
  paddingTop: 16,
  fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
  lineHeight: '22px'
}, function (_ref) {
  var isRtl = _ref.isRtl,
      isNarrow = _ref.isNarrow;
  return {
    direction: isRtl ? 'rtl' : 'ltr',
    flexDirection: isNarrow ? 'row' : 'column'
  };
});

var Content = _glamorous2.default.div({
  flex: '1 1 auto',
  '& mark': {
    backgroundColor: 'transparent !important',
    color: _.Colors.GREEN1,
    borderBottom: '2px solid ' + _.Colors.GREEN1 + ' !important'
  }
});

var Actions = _glamorous2.default.div({
  //flex: '0 1 80px', // not isRtl compliant
});

var Title = _glamorous2.default.span({
  fontSize: _.FontSizes.SIZE1,
  fontWeight: 'bold',
  color: _.Colors.BLUE1,
  cursor: 'pointer',
  '&:hover': {
    borderBottom: '2px solid ' + _.Colors.BLUE1
  }
});

var Description = _glamorous2.default.div({
  color: _.Colors.GREY4,
  margin: '0 0 5px 0',
  padding: '5px 0 5px 0',
  lineHeight: '1.5'
});

var Topics = _glamorous2.default.div({
  fontStyle: 'italic'
});

var LastUpdated = _glamorous2.default.div({
  paddingBottom: 16,
  color: _.Colors.GREY5
});

var SearchDataflow = function SearchDataflow(_ref2) {
  var isRtl = _ref2.isRtl,
      isNarrow = _ref2.isNarrow,
      title = _ref2.title,
      description = _ref2.description,
      topics = _ref2.topics,
      id = _ref2.id,
      matches = _ref2.matches,
      lastUpdated = _ref2.lastUpdated,
      lastUpdatedLabel = _ref2.lastUpdatedLabel,
      dimensionLabel = _ref2.dimensionLabel,
      topicLabel = _ref2.topicLabel,
      selectDataflow = _ref2.selectDataflow;

  return _react2.default.createElement(
    Wrapper,
    { isRtl: isRtl, isNarrow: isNarrow },
    _react2.default.createElement(
      Content,
      null,
      _react2.default.createElement(
        Title,
        { onClick: function onClick() {
            return selectDataflow(id);
          } },
        title
      ),
      _react2.default.createElement(
        Description,
        null,
        description,
        matches
      ),
      _react2.default.createElement(
        Topics,
        null,
        topicLabel,
        topics
      ),
      _react2.default.createElement(
        LastUpdated,
        null,
        lastUpdatedLabel(lastUpdated)
      )
    ),
    _react2.default.createElement(Actions, null)
  );
};

SearchDataflow.propTypes = {
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  id: _propTypes2.default.string.isRequired,
  lastUpdated: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  matches: _propTypes2.default.array,
  topics: _propTypes2.default.array.isRequired,
  isRtl: _propTypes2.default.bool,
  isNarrow: _propTypes2.default.bool,
  selectDataflow: _propTypes2.default.func.isRequired,
  topicLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  dimensionLabel: _propTypes2.default.string,
  lastUpdatedLabel: _propTypes2.default.func.isRequired
};

var DESearchDataflow = exports.DESearchDataflow = (0, _withDataflow.withDataflow)(SearchDataflow);


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-search-dataflow/index.js
// module id = 2017
// module chunks = 0